import React from "react";
import { useShallow } from "zustand/react/shallow";
import { HandsSwapped } from "@uno/protocol";
import useStoreAnimation from "../../../store/useStoreAnimation";
import useStoreRoomScene from "../../../store/useStoreRoomScene";
import SwapHandsAnimation, { SWAP_HANDS_ANIMATION_ID } from "../../../animation/SwapHandsAnimation";
import { useSounds } from "../../../context/SoundContext";

const useRoomPlayersSwappedHands = () => {
    const enqueueAnimation = useStoreAnimation(useShallow(state => state.enqueue));
    const refreshRoomScene = useStoreRoomScene(useShallow(state => state.refresh));
    const { play } = useSounds();

    return React.useCallback((payload: HandsSwapped) => {
        payload.swaps.forEach(({ from }) => refreshRoomScene(from, []));
        enqueueAnimation(SWAP_HANDS_ANIMATION_ID, { ...SwapHandsAnimation(payload.swaps), payload });
        play("flipCard");
    }, []);
};

export default useRoomPlayersSwappedHands;
